<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex xs9>
          <h2>
            {{ $t('Link with Facebook TAG') }}
            <a
              href="https://tinyurl.com/mr3xrzrs"
              target="blank"
              ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
            ></a>
          </h2>
          <span>
            {{ $t('Turn on/off') }} {{ $t('Link with Facebook TAG') }} ({{
              $t(
                'Remark : This feature requires permission to accept the Terms and Conditions to sync tags with Facebook.'
              )
            }})</span
          >
        </v-flex>
      </v-layout>
      <div style="position: relative;" :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '245px' : '0px' }">
        <v-premium-plan-popup
          :showAll="false"
          v-if="$store.getters.getPackage != 'premium'"
          style="border-radius: 10px"
          text="Upgrade to Premium, starting at 500 baht / month to be notified every chatbot’s movement via your personal line/line group. Such as the question that bot cannot answer or when the order comes in"
        ></v-premium-plan-popup>
        <toggle-button
          v-else
          class="mt-2 mb-2"
          :value="fbsyncTag"
          :sync="true"
          :color="$vuetify.theme.success"
          @change="toggleFacebookSyncTags"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
      </div>
      
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.fbsyncTag = this.selectedBot.synctagsfacebook_status
  },
  data() {
    return {
      fbsyncTag: false
    }
  },
  methods: {
    toggleFacebookSyncTags() {
      let vm = this
      if (!vm.fbsyncTag) {
        const pageId = !/^[^0-9]/.test(vm.selectedBot.pageid) ? vm.selectedBot.pageid : vm.selectedBot.facebook_page_id
        window.open(`https://www.facebook.com/${pageId}/inbox/page_contact_tos/`)
      }
      vm.fbsyncTag = !vm.fbsyncTag
      var data = {
        params: {
          pageid: vm.selectedBot.pageid
        },
        body: { synctagsfacebook_status: vm.fbsyncTag }
      }

      vm.$store.dispatch('loading')
      api.toggleFacebookSyncTags(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.fbsyncTag = !vm.fbsyncTag
          vm.$store.dispatch('loading')
          return
        }
        vm.$store.dispatch('updateBotDetail')

        vm.$store.dispatch('loading')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/FacebookTags.vue